import {Utility} from '@/utils';

type Body = FormData;

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE' | string;

class axios {
  static request(url: string, method: Method, body?: Body) {
    return new Promise((resolve, reject) => {
      const data = {method, body};
      const URl = Utility.API_URL + url;

      fetch(URl, data)
        .then(res => {
          if (
            res.ok &&
            (res.status === 200 || res.status === 201 || res.status === 204)
          ) {
            return res.json();
          } else {
            if (typeof res.json === 'function') {
              return res.json();
            } else {
              return reject(res);
            }
          }
        })
        .then(resolve)
        .catch(reject);
    });
  }

  static get<T>(url: string) {
    return this.request(url, 'GET') as Promise<T>;
  }

  static post<T>(url: string, body?: Body) {
    return this.request(url, 'POST', body) as Promise<T>;
  }

  static put<T>(url: string, body?: Body) {
    return this.request(url, 'PUT', body) as Promise<T>;
  }

  static delete(url: string) {
    const method = 'DELETE';
    const URL = Utility.API_URL + url;
    return fetch(URL, {method});
  }
}

export default axios;
